import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabase';

export interface ScheduleChangeLog {
  id: string;
  project_id: string;
  schedule_item_id: string | null;
  schedule_item_title: string | null;
  change_type: string;
  old_start_date: string | null;
  old_end_date: string | null;
  new_start_date: string | null;
  new_end_date: string | null;
  old_duration_days: number | null;
  new_duration_days: number | null;
  affected_item_count: number;
  changed_by: string | null;
  changed_by_role: string | null;
  change_reason: string | null;
  is_client_visible: boolean;
  created_at: string;
}

export function useScheduleChangeLog(projectId: string | undefined) {
  const [logs, setLogs] = useState<ScheduleChangeLog[]>([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!projectId) return;
    setLoading(true);
    const { data } = await supabase
      .from('jphph_project_schedule_change_logs')
      .select('*')
      .eq('project_id', projectId)
      .order('created_at', { ascending: false })
      .limit(100);
    setLogs((data as ScheduleChangeLog[]) || []);
    setLoading(false);
  }, [projectId]);

  useEffect(() => {
    load();
  }, [load]);

  return { logs, loading, reload: load };
}